import { render, staticRenderFns } from "./EffectsModule.vue?vue&type=template&id=03f68956&scoped=true"
import script from "./EffectsModule.vue?vue&type=script&lang=js"
export * from "./EffectsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f68956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f68956')) {
      api.createRecord('03f68956', component.options)
    } else {
      api.reload('03f68956', component.options)
    }
    module.hot.accept("./EffectsModule.vue?vue&type=template&id=03f68956&scoped=true", function () {
      api.rerender('03f68956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/EffectsModule.vue"
export default component.exports